import React from "react";

const Footer = () => {
  return (
    <footer className="bg-rose-100 text-gray-700 py-10 mt-12">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">
        {/* Brand */}
        <div>
          <h2 className="text-2xl font-serif text-rose-600 mb-3">GlowAura</h2>
          <p className="text-sm leading-relaxed max-w-sm mx-auto md:mx-0">
            Naturally radiant skincare. Designed with purity, backed by care.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-rose-600">Home</a></li>
            <li><a href="/about" className="hover:text-rose-600">About</a></li>
            <li><a href="/products" className="hover:text-rose-600">Products</a></li>
            <li><a href="/blog" className="hover:text-rose-600">Blog</a></li>
            <li><a href="/contact" className="hover:text-rose-600">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="font-semibold mb-3">Contact</h3>
          <ul className="text-sm space-y-1">
            <li>Email: <a href="mailto:hello@glowaura.com" className="hover:text-rose-600">hello@glowaura.com</a></li>
            <li>Phone: <a href="tel:+919876543210" className="hover:text-rose-600">+91-98765-43210</a></li>
          </ul>
          <p className="text-xs mt-4">&copy; {new Date().getFullYear()} GlowAura. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
